"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _remarkUnImporter = _interopRequireDefault(require("../utils/remark-un-importer"));

var _getScope = _interopRequireDefault(require("../utils/get-scope"));

var _MDX = _interopRequireDefault(require("./MDX"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ErrorRenderer(_ref) {
  var children = _ref.children;
  return _react.default.createElement("pre", {
    className: "mdx-scoped-runtime__error",
    style: {
      overflowX: 'auto',
      background: 'rgba(255, 0, 0, .1)'
    }
  }, "Invalid MDX:\n".concat(children.toString()));
}

ErrorRenderer.propTypes = {
  children: _propTypes.default.shape({
    toString: _propTypes.default.func.isRequired
  }).isRequired
};

var MDXScopedRuntime = /*#__PURE__*/function (_React$Component) {
  _inherits(MDXScopedRuntime, _React$Component);

  function MDXScopedRuntime() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MDXScopedRuntime);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MDXScopedRuntime)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      error: undefined
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onError", function (error) {
      var onError = _this.props.onError;

      _this.setState({
        error: error
      });

      onError(error);
    });

    return _this;
  }

  _createClass(MDXScopedRuntime, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var error = this.state.error;
      var children = this.props.children;

      if (error && children !== prevProps.children) {
        this.setState({
          error: undefined
        }); // eslint-disable-line react/no-did-update-set-state
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      this.onError(error);
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;

      var _this$props = this.props,
          scope = _this$props.scope,
          mdPlugins = _this$props.mdPlugins,
          onError = _this$props.onError,
          props = _objectWithoutProperties(_this$props, ["scope", "mdPlugins", "onError"]);

      if (error) {
        return _react.default.createElement(ErrorRenderer, null, error);
      }

      try {
        var resolvedScope = props.allowedImports ? (0, _getScope.default)({
          mdPlugins: mdPlugins,
          hastPlugins: props.hastPlugins,
          mdx: props.children,
          allowedImports: props.allowedImports
        }) : {};
        return _react.default.createElement(_MDX.default, _extends({}, props, {
          scope: _objectSpread({
            Layout: function Layout(_ref2) {
              var children = _ref2.children;
              return children;
            }
          }, scope, resolvedScope),
          mdPlugins: [[_remarkUnImporter.default]].concat(_toConsumableArray(mdPlugins))
        }));
      } catch (err) {
        this.onError(err);
        return _react.default.createElement(ErrorRenderer, null, err);
      }
    }
  }]);

  return MDXScopedRuntime;
}(_react.default.Component);

MDXScopedRuntime.propTypes = {
  scope: _propTypes.default.shape({}).isRequired,
  mdPlugins: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  allowedImports: _propTypes.default.shape({}),
  onError: _propTypes.default.func.isRequired,
  children: _propTypes.default.node
};
MDXScopedRuntime.defaultProps = {
  scope: {},
  mdPlugins: [],
  onError: function onError() {
    return undefined;
  }
};
var _default = MDXScopedRuntime;
exports.default = _default;